import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const PublisherConvertedFileActivities: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_ASA_API}/get-file-activities`),
};

export default PublisherConvertedFileActivities;
